import { SOCIAL_AD_TYPES } from "utils/constants";

import {
	FB_MO_IMAGE_VALIDATORS,
	FB_MO_VIDEO_VALIDATORS,
	FACEBOOK_CAROUSEL_MO_CARD_VALIDATORS,
	FACEBOOK_CAROUSEL_MO_VALIDATORS
} from "social/validators/facebook";

import {
	LINKEDIN_IMAGE_VALIDATORS,
	LINKEDIN_VIDEO_VALIDATORS,
	LINKEDIN_CAROUSEL_VALIDATORS,
	LINKEDIN_CAROUSEL_CARD_VALIDATORS
} from "social/validators/linkedIn";

import {
	PINTEREST_IMAGE_VALIDATORS,
	PINTEREST_VIDEO_VALIDATORS,
	PINTEREST_MAX_WIDTH_VIDEO_VALIDATORS,
	PINTEREST_CAROUSEL_VALIDATORS,
	PINTEREST_CAROUSEL_CARD_VALIDATORS
} from "social/validators/pinterest";

import {
	SNAPCHAT_IMAGE_VALIDATORS,
	SNAPCHAT_VIDEO_VALIDATORS
} from "social/validators/snapchat";

import { TIKTOK_VIDEO_VALIDATORS } from "social/validators/tiktok";

export const VERSION_VALIDATORS_BY_ADTYPE = {
	[SOCIAL_AD_TYPES.FACEBOOK_IMAGE_MO]:FB_MO_IMAGE_VALIDATORS,
	[SOCIAL_AD_TYPES.FACEBOOK_VIDEO_MO]:FB_MO_VIDEO_VALIDATORS,
	[SOCIAL_AD_TYPES.FACEBOOK_CAROUSEL_MO]:{
		...FACEBOOK_CAROUSEL_MO_VALIDATORS,
		...FACEBOOK_CAROUSEL_MO_CARD_VALIDATORS,
	},

	[SOCIAL_AD_TYPES.LINKEDIN_IMAGE]:LINKEDIN_IMAGE_VALIDATORS,
	[SOCIAL_AD_TYPES.LINKEDIN_VIDEO]:LINKEDIN_VIDEO_VALIDATORS,
	[SOCIAL_AD_TYPES.LINKEDIN_CAROUSEL]:{
		...LINKEDIN_CAROUSEL_VALIDATORS,
		...LINKEDIN_CAROUSEL_CARD_VALIDATORS,
	},

	[SOCIAL_AD_TYPES.PINTEREST_IMAGE]: PINTEREST_IMAGE_VALIDATORS,
	[SOCIAL_AD_TYPES.PINTEREST_VIDEO]: PINTEREST_VIDEO_VALIDATORS,
	[SOCIAL_AD_TYPES.PINTEREST_MAX_WIDTH_VIDEO]: PINTEREST_MAX_WIDTH_VIDEO_VALIDATORS,
	[SOCIAL_AD_TYPES.PINTEREST_CAROUSEL]:{
		...PINTEREST_CAROUSEL_VALIDATORS,
		...PINTEREST_CAROUSEL_CARD_VALIDATORS,
	},

	[SOCIAL_AD_TYPES.SNAPCHAT_IMAGE]:SNAPCHAT_IMAGE_VALIDATORS,
	[SOCIAL_AD_TYPES.SNAPCHAT_VIDEO]:SNAPCHAT_VIDEO_VALIDATORS,

	[SOCIAL_AD_TYPES.TIKTOK_VIDEO]:TIKTOK_VIDEO_VALIDATORS,
};


export function buildVersionErrors(values, adType){
	let hasErrors = false
		, mess = {}
		;

	let validators = VERSION_VALIDATORS_BY_ADTYPE[adType];

	if(!validators){ return undefined; }


	Object.entries(values).forEach((v) => {
		let [key, value] = v;

		if(!value?.mapping){ return; }

		let { creativeField } = value.mapping;

		if(validators[creativeField]){
			for(const validator of validators[creativeField]) {
				let message = null;
				if(/image|video|thumb/gi.test(creativeField)){
					message = validator({
						...value,
						id:value.assetId,
					}, values);
				} else {
					message = validator(value.data, values);
				}

				if(message) {
					hasErrors = true;
					mess = {
						...mess,
						[key]:{
							data:message,
						},
					};
				}	//end if(message)
			}	//end for(validators)
		}	//end if(validators)
	});

	if(hasErrors){
		return { ...mess };
	}
}
